import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {isNullOrUndefined} from "util";
import {Observable} from "rxjs/Observable";
import {UsersDetailsService} from "../usersdetails/users.details.service";


@Pipe({
    name: 'avatarPipe'
})
export class AvatarUrlPipe implements PipeTransform {
    constructor(private domSn: DomSanitizer,
                private userDetails: UsersDetailsService) {
    }

    transform(username: string): Observable<string> {
        // return Observable.create((observer) => this.userDetails.drawImage(username).subscribe(htmlEl => observer.next(this.domSn.bypassSecurityTrustHtml(htmlEl.outerHTML)))); // se comento para evitar el llamado de infoBasicUsers
        return Observable.create((observer) => this.userDetails.drawImageUser(username).subscribe(htmlEl => observer.next(this.domSn.bypassSecurityTrustHtml(htmlEl.outerHTML))));
    }
}
